import React, { Component } from "react";
import Swal from 'sweetalert2';
import { Col, Button, Form, FormGroup, Label, Input, FormText } from 'reactstrap';
import { api_url } from "./globalFunction/global_string";
import { GoogleReCaptchaProvider, GoogleReCaptcha } from 'react-google-recaptcha-v3';
import Toggle from 'react-toggle';
import 'react-toggle/style.css';
import "./Form.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';


export class FormRegister extends Component {
  constructor(props) {
    super(props);
    this.state = {
      account_R: '',
      password_R: '',
      name_R: '',
      email_R: '',
      password_R_confirm: '',
      fullName_R: '',
      Net_R: '',
      serviceUnit_R: '',
      serviceOffice_R: '',
      phoneExtension_R: '',
      title_R: '',
      verificationCode: '',
      loggedIn: false,
      refreshReCaptcha: false,
      reCaptchaValue: null,
      isButtonDisabled: false,
      remainingTime: 60,
      scanIP: '',
      scanUrl: '',
      scanSelection: true,
      inputKey: 1
    };
    this.fileInputRef = React.createRef();
  }

  handleReCaptcha = (value) => {
    this.setState({ reCaptchaValue: value });
  }

  handleChange = e => {
    const { name, value } = e.target;
    this.setState({ [name]: value }, () => {
      if (name === 'password_R') {
        this.checkPasswordStrength();
      }
    });
  };
  handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      this.setState({ selectedFile: file });
    }
  };

  componentDidMount() {
    if (process.env.REACT_APP_ENABLE_RECAPTCHA === 'true') {
      this.handleRefreshReCaptcha();
    }
  }

  handleRefreshReCaptcha = () => {
    this.setState(prevState => ({ refreshReCaptcha: !prevState.refreshReCaptcha }));
  };

  handleToggleChange = () => {
    this.setState(prevState => ({
      scanSelection: !prevState.scanSelection
    }));
  };


  checkPasswordStrength = () => {
    const password = this.state.password_R;
    let message = '';

    if (password.length < 8) {
      message += '密碼至少需要8個字符。';
    }
    if (!/\d/.test(password)) {
      message += '必須包含至少一個數字。';
    }
    if (!/[a-zA-Z]/.test(password)) {
      message += '必須包含至少一個英文字母。';
    }
    if (!/[\W_]/.test(password)) {
      message += '必須包含至少一個特殊符號。';
    }
    this.setState({ passwordMessage: message });
  };

  sendVerificationEmail = async () => {
    let apiUrl = api_url + "/api/Auth/SendRegisterByEmail";
    const formData = new FormData();
    formData.append("E_mail", this.state.email_R);
    this.setState({ isButtonDisabled: true, remainingTime: 60 });
    const timer = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.remainingTime <= 1) {
          clearInterval(timer);
          return { isButtonDisabled: false, remainingTime: 60 };
        }
        return { remainingTime: prevState.remainingTime - 1 };
      });
    }, 1000);
    fetch(apiUrl,
      {
        method: "POST",
        body: formData
      })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          console.error('Error parsing JSON:', error);
          throw error
        };
      })
      .then(data => {
        let arr_status = [String(data.statusCode), data.row, data.detail] //api 回傳判斷
        //console.log("data:", data, arr_status);
        switch (arr_status[0]) {
          case "200":
            Swal.fire({
              icon: 'success',
              title: '【驗證碼已發送到您的郵箱】',
              text: '恭喜'
            });
            break;
          case "400":
            Swal.fire({
              icon: 'error',
              title: `【${data.row}】`,
              text: 'sorry'
            });
            break;
          default:
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }

  handleRegister = (e) => {
    e.preventDefault();
    if (this.state.password_R !== this.state.password_R_confirm) {
      Swal.fire({
        icon: 'error',
        title: '【密碼不匹配】',
        text: '密碼和確認密碼不一致'
      });
      return;
    }
    if (this.state.verificationCode === '') {
      Swal.fire({
        icon: 'error',
        title: '【缺少驗證碼】',
        text: '請先輸入驗證碼'
      });
      return;
    }
    if (this.state.scanSelection === true && !this.state.selectedFile) {
      Swal.fire({
        icon: 'error',
        title: '【缺少網域或IP檔案】',
        text: '選擇申請掃描的檔案必須上傳文件。'
      });
      return;
    } else if (this.state.scanSelection === false) {
      if (!this.state.scanIP || !this.state.scanUrl) {
        Swal.fire({
          icon: 'error',
          title: '【缺少網址和網域】',
          text: '掃描的IP和掃描的網域都必須填寫。'
        });
        return;
      }
    }
    const reCaptchaValue = this.state.reCaptchaValue;
    let apiUrl = api_url + "/api/Auth/CreateAsync0101";

    const formData = new FormData();
    formData.append("User_id", this.state.account_R);
    formData.append("Password", this.state.password_R);
    formData.append("User_name", this.state.fullName_R);
    formData.append("E_mail", this.state.email_R);
    formData.append("servicenet", this.state.Net_R);
    formData.append("serviceUnit", this.state.serviceUnit_R);
    formData.append("serviceOffice", this.state.serviceOffice_R);
    formData.append("phoneExtension", this.state.phoneExtension_R);
    formData.append("title", this.state.title_R);
    if (process.env.REACT_APP_ENABLE_RECAPTCHA === 'true') {
      formData.append("reCaptchaValue", reCaptchaValue);
    }
    formData.append("verificationCode", this.state.verificationCode);
    if (this.state.scanSelection === false) {
      formData.append("scanUrl", this.state.scanUrl);
      formData.append("scanIP", this.state.scanIP);
    } else if (this.state.scanSelection === true) {
      formData.append('excelFile', this.state.selectedFile);
    }

    fetch(apiUrl,
      {
        method: "POST",
        body: formData
      }).then((response) => response.json())
      .then(data => {
        console.log(data)
        let arr_status = [String(data.statusCode), data.row, data.detail] //api 回傳判斷
        //console.log("data:", data, arr_status);
        // console.log("data:", arr_status[0]);

        switch (arr_status[0]) {
          case "200": //將Token寫入browser
            Swal.fire({
              icon: 'success',
              title: '【註冊成功】',
              text: '恭喜'
            });
            this.setState({
              account_R: '',
              password_R: '',
              name_R: '',
              email_R: '',
              password_R_confirm: '',
              fullName_R: '',
              Net_R: '',
              Unit_R: '',
              serviceUnit_R: '',
              serviceOffice_R: '',
              phoneExtension_R: '',
              title_R: '',
              verificationCode: '',
              isRecaptchaVerified: false,
              scanIP: '',
              scanUrl: '',
              selectedFile: null,
              remainingTime: 0,
              inputKey: this.state.inputKey + 1
            });
            if (this.fileInputRef.current) {
              this.fileInputRef.current.value = '';
            }
            break;
          case "401":
            Swal.fire({
              icon: 'error',
              title: '【註冊資料不正確】',
              text: 'sorry'
            });
            break;
          case "400":
            Swal.fire({
              icon: 'error',
              title: `${data.row}`,
              text: 'sorry'
            });
            break;
          default:

        }

      }).finally(() => {
        if (process.env.REACT_APP_ENABLE_RECAPTCHA === 'true') {
          this.handleRefreshReCaptcha();
        }
      })

      .catch(error => {
        console.error('Error:', error);
      });
  }

  handleDownload = async () => {
    const fileName = '教育體系網站弱點掃描服務註冊網址匯入範本.xlsx';
    const fileUrl = `${api_url}/${fileName}`;
    console.log(fileUrl)
    const response = await fetch(fileUrl);
    const blob = await response.blob();

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }



  render() {
    return (
      <Form onSubmit={this.handleRegister}>
        <FormGroup row className="mb-3">
          <Label for="account_R" sm={2} className="text-right"><span className="text-danger">*</span>帳號</Label>
          <Col sm={10}>
            <Input type="text" name="account_R" placeholder="Username" value={this.state.account_R} onChange={this.handleChange} onBlur={this.checkAccountAvailability} required />
          </Col>
        </FormGroup>
        <FormGroup row className="mb-3">
          <Label for="password_R" sm={2} className="text-right"><span className="text-danger">*</span>密碼</Label>
          <Col sm={10}>
            <Input type="password" name="password_R" placeholder="Password" value={this.state.password_R} onChange={this.handleChange} required />
            <div className="text-danger">
              {this.state.passwordMessage}
            </div>
          </Col>
        </FormGroup>
        <FormGroup row className="mb-3">
          <Label for="password_R_confirm" sm={2} className="text-right"><span className="text-danger">*</span>確認密碼</Label>
          <Col sm={10}>
            <Input type="password" name="password_R_confirm" placeholder="Password check" value={this.state.password_R_confirm} onChange={this.handleChange} required />
          </Col>
        </FormGroup>
        <FormGroup row className="mb-3">
          <Label for="fullName_R" sm={2} className="text-right"><span className="text-danger">*</span>姓名</Label>
          <Col sm={8}>
            <Input type="text" name="fullName_R" placeholder="王小名" value={this.state.fullName_R} onChange={this.handleChange} required />
          </Col>
        </FormGroup>
        <FormGroup row className="mb-3">
          <Label for="email_R" sm={2} className="text-right"><span className="text-danger">*</span>信箱</Label>
          <Col sm={6}>
            <Input type="email" name="email_R" placeholder="Email" value={this.state.email_R} onChange={this.handleChange} required />
          </Col>
          <Col sm={2}>
            <Button
              color="primary"
              onClick={this.sendVerificationEmail}
              disabled={this.state.isButtonDisabled}
            >
              {this.state.isButtonDisabled ? `重新發送(${this.state.remainingTime}s)` : "發送驗證碼"}
            </Button>
          </Col>
          <Col sm={2}>
            <Input type="text" name="verificationCode" placeholder="驗證碼" value={this.state.verificationCode} onChange={this.handleChange} required />
          </Col>
        </FormGroup>
        <FormGroup row className="mb-3">
          <Label for="Net_R" sm={2} className="text-right"><span className="text-danger">*</span>區網</Label>
          <Col sm={10}>
            <Input type="text" name="Net_R" placeholder="請填寫對應的區網單位 例如：竹苗區網、中央研究院" value={this.state.Net_R} onChange={this.handleChange} />
          </Col>
        </FormGroup>
        <FormGroup row className="mb-3">
          <Label for="serviceUnit_R" sm={2} className="text-right"><span className="text-danger">*</span>服務單位</Label>
          <Col sm={4}>
            <Input type="text" name="serviceUnit_R" placeholder="國立陽明交通大學" value={this.state.serviceUnit_R} onChange={this.handleChange} required />
          </Col>
          <Label for="serviceOffice_R" sm={2} className="text-right"><span className="text-danger">*</span>服務處室</Label>
          <Col sm={4}>
            <Input type="text" name="serviceOffice_R" placeholder="資訊技術服務中心" value={this.state.serviceOffice_R} onChange={this.handleChange} required />
          </Col>
        </FormGroup>
        <FormGroup row className="mb-3">
          <Label for="phoneExtension_R" sm={2} className="text-right"><span className="text-danger">*</span>電話分機</Label>
          <Col sm={10}>
            <Input type="text" name="phoneExtension_R" placeholder="電話分機(030000000)分機(#123)" value={this.state.phoneExtension_R} onChange={this.handleChange} required />
          </Col>
        </FormGroup>
        <FormGroup row className="mb-3">
          <Label for="title_R" sm={2} className="text-right">職稱</Label>
          <Col sm={10}>
            <Input type="text" name="title_R" placeholder="組長" value={this.state.title_R} onChange={this.handleChange} />
          </Col>
        </FormGroup>
        <FormGroup row className="mb-3">
          <Label for="title_R" sm={2} className="text-right">申請掃描檔案</Label>
          <Col sm={10}>
            <Toggle
              checked={this.state.scanSelection}
              onChange={this.handleToggleChange}
            />
          </Col>
        </FormGroup>
        {
          this.state.scanSelection && (
            <FormGroup row className="mb-3">
              <Label for="scanFile" sm={2} className="text-right">
                <span className="text-danger">*</span>申請掃描的檔案
              </Label>
              <Col sm={6}>
                <Input
                  type="file"
                  name="scanFile"
                  id="scanFile"
                  onChange={this.handleFileChange}
                  key={this.state.inputKey}
                  ref={this.fileInputRef}
                />
                <FormText color="muted">
                  檔案一經註冊後不能修改，請確認填寫資訊是否正確。
                </FormText>
              </Col>
              <Col sm={4} >
                <FontAwesomeIcon
                  icon={faFileExcel}
                  size="2x"
                  onClick={this.handleDownload}
                  style={{ cursor: 'pointer' }}
                />
              </Col>
            </FormGroup>
          )
        }
        {
          !this.state.scanSelection && (
            <>
              <FormGroup row className="mb-3">
                {/* 申請掃描的IP */}
                <Label for="scanIP" sm={2} className="text-right">
                  <span className="text-danger">*</span>申請掃描的IP
                </Label>
                <Col sm={10}>
                  <textarea
                    className="form-control"
                    name="scanIP"
                    id="scanIP"
                    placeholder="格式：127.0.0.1/8,192.168.1.1"
                    value={this.state.scanIP}
                    onChange={this.handleChange}
                    rows="5"
                    style={{ whiteSpace: 'pre-wrap' }}
                  />
                  <FormText color="muted">
                    IP一經註冊後不能修改，請確認填寫資訊是否正確。
                  </FormText>
                </Col>
              </FormGroup>

              <FormGroup row className="mb-3">
                {/* 申請掃描的網域 */}
                <Label for="scanUrl" sm={2} className="text-right">
                  <span className="text-danger">*</span>申請掃描的網域
                </Label>
                <Col sm={10}>
                  <textarea
                    className="form-control"
                    name="scanUrl"
                    id="scanUrl"
                    placeholder="範例：nycu.edu.tw,va.nycu.edu.tw"
                    value={this.state.scanUrl}
                    onChange={this.handleChange}
                    rows="5"
                    style={{ whiteSpace: 'pre-wrap' }}
                  />
                  <FormText color="muted">
                    網域一經註冊後不能修改，請確認填寫資訊是否正確。
                  </FormText>
                </Col>
              </FormGroup>
            </>
          )
        }
        
        {process.env.REACT_APP_ENABLE_RECAPTCHA === 'true' && (
          <GoogleReCaptcha
            onVerify={this.handleReCaptcha}
            refreshReCaptcha={this.state.refreshReCaptcha}
          />
        )}
        
        <FormGroup row>
          <Col sm={{ size: 10, offset: 2 }}>
            <Button color="primary" type="submit" onClick={this.validateForm}>註冊</Button>
          </Col>
        </FormGroup>
      </Form>
    );
  }
}